module.exports = __webpack_public_path__ + "assets/img/2.8fccd191.png";